import { VideoCameraFront } from "@mui/icons-material";
import { Button } from "@mui/material";

export default function VirtualClassroom({ url, sx }) {
    return url && 
        <Button 
            href={url} 
            rel="noopener noreferrer" 
            target="_blank" 
            startIcon={<VideoCameraFront />}
            sx={sx}
        >
            Classe Virtuelle
        </Button>
}